import API from "../../axios.jsx";

// Disentimiento de vacunación — módulo dentro de BAC. Usa la ruta
// /bac/disentimiento, así el interceptor de axios.jsx le pone solo el
// token de la sesión de BAC (igual que al resto de /bac).
const BASE = "/bac/disentimiento";

export const getDisentimientosBac   = (params) => API.get(BASE, { params });
export const getDisentimientoBac    = (id) => API.get(`${BASE}/${id}`);
// La firma viaja en base64: se da más margen que el timeout general (12 s)
// para no cortar el envío en una conexión lenta de campo.
export const crearDisentimientoBac  = (payload) => API.post(BASE, payload, { timeout: 45000 });
export const generarFichaDisentimientoBac = (id) => API.post(`${BASE}/${id}/generar-ficha`, {}, { timeout: 45000 });
export const eliminarDisentimientoBac     = (id) => API.delete(`${BASE}/${id}`);

// URL pública del PDF de la ficha (lo sirve /uploads del backend)
export const urlFichaDisentimiento = (fichaUrl) =>
  fichaUrl ? `${(API.defaults.baseURL || "").replace(/\/$/, "")}${fichaUrl}` : null;
